import React from "react";

const BannerFooterShape = () => {
  return (
    <svg
      width="631"
      height="107"
      viewBox="0 0 631 107"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M59.1042 69.5C59.1042 48.7893 75.8935 32 96.6042 32H594.751C613.174 32 628.715 18.2812 631 0V107H0H21.6042C42.3149 107 59.1042 90.2107 59.1042 69.5Z"
        fill="white"
      />
    </svg>
  );
};

export default BannerFooterShape;
